import { render } from "./SingleMainComponent.vue?vue&type=template&id=d239a6aa"
import script from "./SingleMainComponent.vue?vue&type=script&lang=js"
export * from "./SingleMainComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kreigdurham/Documents/Git/af3-shortcodes/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__